import styled from 'styled-components';

export const ClientBasedDescriptionSectionContainer = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  width: 100%;
  height: 100%;
  color: white;
  @media (max-width: 768px) {
    order: -1;
    margin-bottom: 72px;
    margin-top: 48px;
  }
`;
